
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'boolean',
        field: 'ativo',
        label: 'Habilitar envio de Lotes',
        info: 'Ao habilitar essa opção o sistema vai enviar automaticamente (todo dia as 00:00) os lotes para seus clientes.',
        clearable: true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10',
        type: 'date',
        field: 'data_inicio',
        label: 'Iniciar Envio EM',
        info: 'Data de inicio do envio dos Lotes.',
        clearable: true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-custom',
        field: 'empresas',
        label: 'Empresa - Gerar Lote',
        option: {
            key: 'id',
            label: 'nome',
            value: 'id'
        },
        info: 'Selecione as empresas que receberam os emails de Lotes do Esocial. Deixe em branco para enviar a todas as empresas.',
        placeholder:'Todas',
        clearable: true,
        multiple:true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-custom',
        field: 'empresas_processar',
        label: 'Empresa - Processar Lote',
        option: {
            key: 'id',
            label: 'nome',
            value: 'id'
        },
        info: 'Selecione as empresas que serão enviados os lotes processados diretamente para o eSocial.',
        clearable: true,
        multiple:true,
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/esocial/configuracao/_form/configuracao.js